import React, { useEffect, useState } from "react";
import Input from "./Input";
import { Search, X } from "lucide-react";
import { useDebounce } from "src/hooks/useDebounce";

interface SearchInputProps {
  label: string;
  name: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  label,
  name,
  type,
  placeholder,
  value,
  onChange,
}) => {
  const [searchText, setSearchText] = useState(value);
  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    onChange({
      target: { value: debouncedSearchText },
    } as React.ChangeEvent<HTMLInputElement>);
  }, [debouncedSearchText, onChange]);

  return (
    <Input
      name={name}
      label={label}
      placeholder={placeholder}
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      fullWidth
      type={type}
      startAdornment={<Search className="ml-2 w-4 h-4 text-gray-400" />}
      endAdornment={
        searchText && (
          <button
            className="mr-1 p-1 border border-gray-300 bg-gray-100 rounded-full"
            onClick={() => setSearchText("")}
          >
            <X className="w-3 h-3 text-gray-400" />
          </button>
        )
      }
    />
  );
};

export default SearchInput;
